import { BaseCommand } from './ICommand';
import { IEventBus } from '../events/IEventBus';

interface BeginCommentPlacementCommandProps {
  beginPlacement: () => void;
  cancelPlacement: () => void;
  eventBus: IEventBus;
}

export class BeginCommentPlacementCommand extends BaseCommand {
  private readonly beginPlacement: () => void;
  private readonly cancelPlacement: () => void;
  private readonly eventBus: IEventBus;
  private isActive = false;

  constructor({ beginPlacement, cancelPlacement, eventBus }: BeginCommentPlacementCommandProps) {
    super('Begin Comment Placement', 'Enter comment placement mode', {
      skipHistory: true,
      executionScope: 'annotation',
    });
    this.beginPlacement = beginPlacement;
    this.cancelPlacement = cancelPlacement;
    this.eventBus = eventBus;
  }

  async execute(): Promise<void> {
    if (this.isActive) {
      return;
    }
    this.beginPlacement();
    this.isActive = true;
  }

  async undo(): Promise<void> {
    if (!this.isActive) {
      return;
    }
    this.cancelPlacement();
    this.eventBus?.emit('comment:placement:cancelled');
    this.isActive = false;
  }

  async redo(): Promise<void> {
    await this.execute();
  }
}
